import './footer.css'
const FooterComponent = () => {
    return (
      <footer className="footerContainer">
        © Mark S. Roberts {new Date().getFullYear()}
      </footer>
    )
}

export default FooterComponent
